// extracted by mini-css-extract-plugin
module.exports = {"container":"_f391661","button":"_48fce21","withArrows":"_95929fc","right":"_45c8da5"};